import { clsx, type ClassValue } from "clsx";
import {  Users } from "lucide-react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const sliderData = [
  {
    title: "Confection des tenues scolaires",
    description: "Un programme ambitieux visant à soutenir les artisans locaux à travers la production de millions de tenues scolaires. Ce projet valorise le savoir-faire sénégalais tout en garantissant des vêtements de qualité pour les élèves du pays.",
    image: "/slider/confection-des-tenues-scolaires.webp",
    stats: "4M+ tenues scolaires confectionnées au profit des écoles sénégalaises.",
    icon: Users,
    color: "from-[#1E3D1A]/90 to-[#069861]/90",
  },
  {
    title: "Formations Modulaires",
    description: "Des programmes de formation sur mesure, pensés pour renforcer les compétences des artisans et répondre aux exigences spécifiques de chaque métier. Grâce à une approche pratique et adaptée, chaque artisan bénéficie d'un accompagnement personnalisé pour améliorer sa performance et développer de nouvelles expertises.",
    image: "/slider/formations-fodulaires.webp",
    stats: "980+ artisans formés avec succès à travers tout le Sénégal.",
    icon: Users,
    color: "from-[#1E3D1A]/90 to-[#069861]/90",
  },
  {
    title: "Équipements Modernes",
    description: "Des outils et machines de dernière génération mis à disposition pour garantir un travail de qualité, conforme aux standards internationaux. Ces équipements modernes permettent aux artisans d'améliorer leur productivité, leur précision et de répondre efficacement aux exigences des marchés publics.",
    image: "/slider/equipements-modernes.webp",
    stats: "450+ équipements installés et opérationnels dans les ateliers artisanaux.",
    icon: Users,
    color: "from-[#1E3D1A]/90 to-[#069861]/90",
  },
  {
    title: "Réhabilitation de Tables-Bancs dans les 14 Régions",
    description: "Un vaste programme de réhabilitation mené à travers les 14 régions du Sénégal pour redonner vie aux tables-bancs des établissements scolaires. Une action concrète pour améliorer les conditions d’apprentissage des élèves et soutenir l’artisanat local.",
    image: "/slider/tables-bancs.webp",
    stats: "124 800+ tables-bancs réhabilités dans tout le pays.",
    icon: Users,
    color: "from-[#1E3D1A]/90 to-[#069861]/90",
  },
  {
    title: "ZAMPA",
    description: "La Zone d'Activité des Mécaniciens et des Professionnels de l'Automobile (ZAMPA) est un espace moderne entièrement dédié aux métiers de la mécanique et des services automobiles. Elle offre aux artisans un cadre structuré, propice au développement de leurs activités et à l'amélioration de leurs conditions de travail.",
    image: "/slider/zampa.webp",
    stats: "62 hectares+ dédiés aux artisans et professionnels de l'automobile.",
    icon: Users,
    color: "from-[#1E3D1A]/90 to-[#069861]/90",
  },
  {
    title: "Confection de masques de la COVID-19",
    description: "Une initiative solidaire portée par les artisans pour fabriquer des masques de protection durant la pandémie de COVID-19. Ce projet a contribué à renforcer les mesures sanitaires en fournissant des équipements de qualité, faits localement, au service des communautés.",
    image: "/slider/confection-de-masque.webp",
    stats: "1M+",
    icon: Users,
    color: "from-[#1E3D1A]/90 to-[#069861]/90",
  },
  
];

export const articles: Article[] = [
  
  {
    id: "PMNX25",
    slug: "partenariat_entre_pmn_arcop_acces_commande_public",
    image: "/images/partenariat_entre_pmn_arcop_acces_commande_public.jpg",
    title:
      "Partenariat entre le PMN et l’ARCOP pour faciliter aux artisans l’accès à la commande publique",
    description:
      "Le Projet Mobilier National (PMN) a offert une session de formation sur l’accès aux marchés publics à 40 artisans toute filières confondues grâce à un partenariat avec l’Autorité de Régulation de la Commande Publique (ARCOP).\n Cette formation tenue du 19 au 21 août 2025 à l’Institut de formation IRCOP s’inscrit dans le cadre de la promotion du secteur artisanal, conformément à la politique sectorielle du ministère du Tourisme et de l’Artisanat.\nLors de la cérémonie de démarrage de la formation, le Coordonnateur du PMN, M. Ibrahima TALL, a salué « cette belle opportunité offerte aux artisans de Dakar » à travers ce partenariat avec l’ARCOP qui permettra un renforcement de capacités des artisans pour ainsi plus de facilité d’accès à la commande publique.\nRappelant les nombreux mécanismes mis en place par l’État du Sénégal pour soutenir le secteur informel, M. TALL a souligné le Projet Mobilier National figure parmi les leviers essentiels à la promotion de l’artisanat et à la création d’emplois, ainsi qu’au renforcement de la compétitivité et de valeur ajoutée locale, en droite ligne avec les orientations du Ministre du Tourisme et de l’Artisanat, M. Mountaga DIAO.\n« La mission du Projet Mobilier National est d’accompagner les artisans à mieux répondre aux exigences de la commande publique par la formalisation, la formation, le financement et l’accès au foncier », a rappelé le Coordonnateur.\nCependant, il estime que les opportunités offertes au secteur informel en général et aux artisans en particulier restent encore peu exploitées, notamment les marchés publics, aussi bien au niveau national que local.\nSelon M. TALL, cette situation s’explique en partie par un manque de connaissance des procédures et des avantages qu’offre le nouveau Code des marchés publics, d’où la pertinence de cette formation pour répondre à cette contrainte.\nS’adressant aux participants, majoritairement responsables d’Organisations Professionnelles d’Artisans (OPA), chefs d’entreprises artisanales et formateurs dans leur domaine, le Coordonnateur a reconnu leur expertise mais a insisté sur la nécessité de renforcer leurs compétences en matière de réglementation.\n« Je leur demande de s’approprier cette formation pour mieux maîtriser toute la procédure de la Commande publique et en saisir les avantages », a-t-il déclaré.\nPour sa part, le Directeur général de l’ARCOP, Dr Moustapha DJITTÉ, a réaffirmé son ambition d’« endogénéiser » la commande publique afin qu’elle profite davantage aux opérateurs nationaux. Selon lui, la méconnaissance des textes prive encore trop souvent les entreprises locales de marchés pourtant accessibles.\nMais au-delà de la sensibilisation, l’ARCOP veut privilégier le concret. La maîtrise du Code des marchés fait partie de ses priorités. S’y ajoutent la structuration des offres conformes, le respect des normes et la production des fiches techniques solides. L’organe de régulation entend également s’assurer de la bonne application des mesures de préférence en faveur des artisans, afin que la commande publique devienne un levier réel de développement économique.\nEn effet, une convention-cadre est en préparation pour étendre ces actions dans les régions et renforcer la professionnalisation des filières liées au mobilier et aux métiers connexes, avec pour objectif de combiner formation, information et accompagnement méthodologique pour ouvrir plus largement l’accès des artisans à la commande publique.\nM. DJITTÉ a également rappelé la nécessité pour les artisans de créer des produits durables, conformes aux standards, et appuyés par une documentation technique irréprochable. Il estime que la maîtrise des procédures et la structuration d’offres solides sont des leviers déterminants pour élargir le tissu économique national, créer des emplois qualifiés et renforcer la valeur ajoutée locale.",
    date: "2025-09-21",
  },
  {
    id: "PMNG25",
    slug: "promotion-de-la-production-locale-gendarmerie-nationale",
    image: "/images/promotion-de-la-production-locale-gendarmerie-nationale.webp",
    title:
      "🇸🇳 Promotion de la production locale : Le Projet Mobilier National à l’écoute des besoins de la Gendarmerie nationale",
    description:
      "Dakar, le 17 avril 2025 – Dans le cadre de sa mission de valorisation de la production artisanale locale, le Projet Mobilier National (PMN) a été reçu ce mercredi 16 avril par le Haut commandement de la Gendarmerie nationale, à la Caserne Samba Diery Diallo, sous la présidence du Général de Division Martin Faye.\nCette rencontre stratégique avait pour objectif de présenter une gamme de produits conçus par des artisans sénégalais, notamment des tenues et des chaussures destinées aux forces de défense et de sécurité. Une initiative qui s’inscrit pleinement dans la dynamique de consommation locale et de soutien à l’artisanat national, portée par les orientations du New Deal technologique.\nDans une atmosphère empreinte de respect et de patriotisme, le coordonnateur du PMN, M. Ibrahima Tall, a détaillé la vision du projet : connecter les besoins institutionnels avec les capacités des artisans sénégalais, tout en garantissant des produits de qualité, conformes aux exigences des corps d’élite.\nLe Général de Division Martin Faye a salué cette démarche, qu’il a qualifiée d’« innovante et stratégique pour l’autonomie nationale », tout en insistant sur la nécessité d’un strict respect des normes techniques, notamment en matière de durabilité, de confort et d’adaptation aux réalités du terrain.\nDes échanges constructifs ont permis de formuler des recommandations techniques, offrant ainsi une feuille de route claire pour un partenariat durable entre le PMN et la Gendarmerie nationale.\nÀ l’issue de la rencontre, le PMN a réaffirmé son engagement à ajuster sa production aux standards des forces de défense, dans un esprit d'amélioration continue et de fierté nationale.Le Général Faye a pour sa part réitéré l'engagement de la Gendarmerie à accompagner cette dynamique, soulignant le rôle clé du secteur artisanal dans la création d’emplois et la consolidation de la souveraineté économique.\n🎯 Le Projet Mobilier National poursuit ainsi sa mission : faire du “Made in Sénégal” une référence d’excellence au sein des institutions publiques.",
    date: "2025-04-17",
  },
  {
    id: "CPM63S",
    slug: "partenariat-pmn-sn-hlm",
    image: "/images/partenariat-pmn-sn-hlm.webp",
    title:
      "Partenariat Stratégique entre le PMN et la SN HLM : Valoriser l’Artisanat et Promouvoir l’Expertise Locale",
    description:
      "Le Projet du Mobilier National (PMN) et la Société Nationale d'Habitation à Loyer Modéré (SN HLM) ont signé une convention de partenariat ce mardi 24 décembre 2024.\n Le Coordonnateur du PMN, M. @Ibrahima Tall et le Directeur général de la SN HLM, M. @Bassirou KEBE, ont marqué par cette action, chacun en ce qui le concerne, leur volonté de travailler en synergie pour donner corps à la vision de Son Excellence M. @Bassirou Diomaye Diakhar FAYE Président de la république, dont la politique est conduit par le Premier Ministre M. @Ousmane SONKO.\n Le PMN entend poursuivre ses actions pour une meilleure concrétisation de son plan stratégique et une mise en œuvre des directives du Ministre du Tourisme et de l'artisanat, M. @Mountaga DIAO pour qui le tourisme et l'artisanat constituent un centre d'intérêt. L’accès à la commande publique des artisans étant un des défis majeurs du PMN, le SN-HLM va beaucoup contribuer dans la valorisation de l'expertise locale et la confirmation du génie Sénégalais à travers une implication des artisans dans les projets de construction, de réfection et d'ameublement.\nLe DG de la SN HLM, M. Bassirou KEBE a réitéré sa volonté d'accompagner le PMN et au delà, tout le secteur artisanal qui occupe une part importante de l'emploi des femmes et des jeunes.",
    date: "2024-12-24",
  },
  {
    id: "KJL12W",
    slug: "kedougou-formation",
    image: "/images/kedougou-formation.webp",
    title:
      "Du 29 mai au 12 juin 2024 : Formation à Kédougou - Un Avancée pour l'Artisanat Local",
    description:
      "Dans le cadre du Projet Mobilier National, en collaboration avec la Chambre des Métiers de Kédougou, une initiative majeure a été lancée pour renforcer les compétences des artisans locaux. Du 29 mai au 12 juin 2024, une formation intensive de 15 jours a été organisée, rassemblant 20 artisans talentueux de la région.\n Ces professionnels ont été formés aux techniques avancées de fabrication de mobilier de bureau, un secteur clé pour le développement économique local. Cette formation est une étape significative pour les menuisiers de Kédougou, leur permettant non seulement de perfectionner leur savoir-faire, mais aussi de s'aligner sur les standards nationaux en matière de qualité et d'innovation.\n Ce partenariat entre le Projet Mobilier National et la Chambre des Métiers de Kédougou marque un tournant dans la valorisation de l'artisanat local, offrant aux artisans de nouvelles opportunités pour se démarquer sur le marché et contribuer au développement de leur région. Avec des compétences renforcées, ces artisans sont désormais mieux préparés pour répondre aux exigences du marché et pour participer activement à la dynamisation économique de Kédougou. \nUn grand pas a été franchi pour les menuisiers de la région, ouvrant la voie à un avenir prometteur dans le domaine de la fabrication de mobilier de bureau.",
    date: "2024-06-13",
  },
  {
    id: "KRT61Z",
    slug: "formation-coupe-couture-de-tenues",
    image: "/images/formation-coupe-couture-de-tenues.webp",
    title:
      "Du 29 juillet au 12 août 2024 à Kaolack : Formation en Coupe et Couture de Tenues de Gouverneur (Vareuses)",
    description:
      "Le Projet Mobilier National, en partenariat avec la Chambre des Métiers de Kaolack, a récemment conclu une formation intensive qui marque une étape importante pour l'artisanat de la région. Du 29 juillet au 12 août 2024, 20 artisans talentueux ont eu l'opportunité de perfectionner leurs compétences en coupe et couture, spécifiquement dans la confection des tenues de gouverneur, connues sous le nom de vareuses. \n Cette formation de 15 jours, qui s'est déroulée à Kaolack, a permis aux participants de maîtriser l'art de la couture haut de gamme, un domaine qui nécessite précision, expertise et un sens aigu du détail. Les artisans ont bénéficié d'un encadrement rigoureux, leur permettant de se familiariser avec les techniques avancées nécessaires pour produire des tenues de gouverneur, qui exigent un savoir-faire exceptionnel et une grande rigueur dans l'exécution.\n La Chambre des Métiers de Kaolack, en collaboration avec le Projet Mobilier National, a mis l'accent sur l'importance de ce type de formation pour élever le niveau de compétence des artisans locaux. L'objectif est de leur permettre non seulement de répondre aux exigences des commandes gouvernementales, mais aussi de renforcer leur compétitivité sur le marché national et international.\n Cette initiative s'inscrit dans une stratégie plus large visant à dynamiser l'économie locale par le développement des compétences artisanales, un secteur clé pour l'emploi et le développement régional. En investissant dans la formation et la spécialisation des artisans, Kaolack se positionne comme un pôle de référence en matière de couture haut de gamme au Sénégal.\n Les artisans formés lors de cette session intensive sont désormais mieux équipés pour produire des pièces d'une qualité exceptionnelle, capables de répondre aux standards élevés des vêtements officiels. Ils repartent avec une expertise renforcée, prête à être mise en œuvre dans leurs ateliers, contribuant ainsi à la croissance de l'industrie artisanale de la région.\n Ce projet témoigne de l'engagement continu du Projet Mobilier National et de la Chambre des Métiers de Kaolack à soutenir les artisans locaux, en leur offrant des opportunités de formation et de perfectionnement qui les aident à prospérer dans un marché de plus en plus concurrentiel. Grâce à cette initiative, les artisans de Kaolack sont mieux préparés à relever les défis de demain, tout en préservant et en valorisant le riche patrimoine artisanal du Sénégal.",
    date: "2024-09-15",
  },
  {
    id: "PXE63S",
    slug: "ceremonie-de-passation-de-service",
    image: "/images/ceremonie-de-passation-de-service.webp",
    title:
      "M. Ibrahima Tall Succède à M. Saloum Ndiaye à la Coordination du Projet Mobilier National",
    description:
      "Nous vous informons que la passation de service entre M. Saloum Ndiaye, ancien coordonnateur du Projet Mobilier National (PMN), et son successeur, M. Ibrahima Tall, s'est déroulée avec succès. Le nouveau coordonnateur et son adjoint ont salué le travail accompli par M. Ndiaye.M. Saloum Ndiaye, reconnu pour son engagement sans faille et ses compétences en gestion, a transmis le flambeau après avoir contribué de manière significative à l'avancement du PMN.\n Sous sa direction, le projet a franchi des étapes cruciales, posant des bases solides pour un avenir prometteur pour les artisans sénégalais. Son leadership, son esprit managérial et sa dimension sociale, largement appréciés par ses collègues et collaborateurs, ont permis de transformer le PMN en une structure autonome et compétente, réalisant ainsi le rêve des artisans. \n Lors de son discours, M. Ndiaye a félicité et encouragé le nouveau coordonnateur et son équipe, leur souhaitant des réussites qui surpassent les attentes. La passation s'est terminée par un échange de cadeaux entre les deux parties et des séances de photos. M. Ibrahima Tall, nouveau coordonnateur du PMN, accompagné de son équipe, s'engage à poursuivre le travail déjà entamé et à élargir les activités du projet pour en faire bénéficier tous les artisans.\n Sa prise de fonction marque le début d'une nouvelle ère pour le PMN, avec pour mission principale de soutenir les artisans afin que leurs œuvres deviennent plus compétitives sur le marché public. Promouvoir le savoir-faire local est un acte de patriotisme, et sa perfection est essentielle pour affronter la concurrence mondiale.\n Nous lui souhaitons la bienvenue dans ses nouvelles fonctions, ainsi que beaucoup de succès dans cette responsabilité importante. Le Projet Mobilier National reste déterminé à poursuivre ses objectifs de développement, de promotion de l'artisanat local, et d'innovation, sous la direction éclairée de M. Ibrahima Tall.",
    date: "2024-09-18",
  },
  {
    id: "RMB63S",
    slug: "coordonnatrice-ramatoulaye-ba",
    image: "/images/coordonnatrice-ramatoulaye-ba.webp",
    title:
      "Nouveau Leadership au Projet Mobilier National : Mme Ramatoulaye Ba Nommée Coordonnateur Adjoint",
    description:
      "Mme Ramatoulaye Ba, économiste chevronnée, a été nommée Coordonnateur adjoint. Auparavant à la tête du projet des Centres d'Initiatives pour l'Emploi Local (CIEL) au sein de la Direction de l'Emploi, Mme Ba apporte une riche expérience et une expertise avérée en matière de gestion de projets et de développement économique.\nSon parcours à la Direction de l'Emploi, marqué par une vision stratégique et une gestion efficace des initiatives locales, a contribué à sa reconnaissance comme l'une des figures montantes dans le domaine du développement économique. Sa nomination au poste de Coordonnatrice du PMN témoigne de la confiance placée en elle pour guider ce projet vers de nouveaux horizons.\nMme Ba travaillera en étroite collaboration avec M. Ibrahima Tall, récemment nommé Coordonnateur du PMN. Ensemble, ils formeront une équipe dirigeante dynamique, prête à relever les défis et à poursuivre l'objectif de faire du Projet Mobilier National un modèle de réussite dans la valorisation du savoir-faire local.\nSous cette nouvelle direction, le PMN se fixe des ambitions renouvelées : accompagner les artisans sénégalais pour qu'ils accèdent à des marchés plus compétitifs et innovants, et promouvoir l'excellence du mobilier local sur la scène nationale et internationale.\n L'arrivée de Mme Ramatoulaye Ba à la tête du projet marque un tournant prometteur, et toute l'équipe du PMN se réjouit de pouvoir compter sur son leadership et sa vision pour les années à venir.",
    date: "2024-10-15",
  },
  {
    id: "SBD63S",
    slug: "visite-Soumbedioune-medina-Khar-yalla",
    image: "/images/visite-Soumbedioune-medina-Khar-yalla.webp",
    title:
      "Le Coordonnateur du Projet Mobilier National en Immersion auprès des Artisans de Soumbédioune, Médina et Khar Yalla",
    description:
      "Dans le cadre de ses nouvelles fonctions, Monsieur Ibrahima Tall, Coordonnateur du Projet Mobilier National (PMN), a effectué une visite enrichissante auprès des artisans de Soumbédioune, Médina et Khar Yalla. Ce déplacement, réalisé en ce début de mois, marque la première étape d’une série de visites qui s’étendra à travers tout le Sénégal.\nMonsieur Tall, soucieux de s’imprégner des réalités du terrain, a rencontré les acteurs de ces quartiers emblématiques pour mieux comprendre leurs besoins et défis. Les échanges ont porté sur des perspectives de collaboration visant à renforcer le secteur artisanal, pilier essentiel du développement économique et culturel du pays.\nCette visite s’inscrit dans la volonté du PMN de placer l’artisanat au cœur de ses priorités. « Travailler main dans la main avec les artisans est crucial pour atteindre nos objectifs de valorisation du savoir-faire local et de compétitivité sur le marché national et international », a souligné Monsieur Tall.\nLes artisans de Soumbédioune, Médina et Khar Yalla ont accueilli favorablement cette démarche, exprimant leur gratitude pour l’intérêt porté à leurs activités. Ils ont également partagé leurs attentes concernant l’accompagnement et le soutien nécessaires pour améliorer leurs conditions de travail et accéder à de nouvelles opportunités.\nMonsieur Ibrahima Tall prévoit d’intensifier ces rencontres dans les semaines à venir, avec pour ambition de visiter d’autres régions du Sénégal. L’objectif est de créer un réseau de collaboration solide entre le PMN et les artisans, favorisant ainsi le développement durable du secteur.\nLe Projet Mobilier National, sous la direction de Monsieur Tall, réaffirme son engagement à soutenir l’artisanat sénégalais en mettant en avant le talent et le savoir-faire local. Cette initiative marque le début d’une nouvelle ère de partenariat, propice à la croissance et à l’innovation dans le domaine artisanal.",
    date: "2024-10-23",
  },
  {
    id: "APS63S",
    slug: "senegal-artisanat-vision",
    image: "/images/senegal-artisanat-vision.webp",
    title:
      "SENEGAL-ARTISANAT-VISION / Projet mobilier national : Ibrahima Tall promet un management ‘’efficace, efficient et inclusif’’ pour réussir sa mission",
    description:
      "Diamniadio, 14 août (APS) – ‘’Un management efficace, efficient et inclusif’’ est la condition sine qua non pour ‘’optimiser les chances de réussite du Projet mobilier national’’, estime le nouveau coordonnateur dudit projet, Ibrahima Tall.\n‘’Pour optimiser les chances de réussite du Projet mobilier national, il y a lieu d’assurer un management efficace, efficient et inclusif. Ce mode de gouvernance suppose la mise en œuvre de mécanismes de consultation et de concertation avec les acteurs et les partenaires’’, a-t-il indiqué, dans un discours dont copie est parvenue à l’APS.\nIbrahima Tall s’exprimait lors de sa prise officielle de fonction, au terme d’une cérémonie de passation de service avec son prédécesseur, Saloum Ndiaye. Cette cérémonie s’est tenue à la sphère ministérielle Habib Thiam de Diamniadio, en présence de plusieurs officiels et acteurs du secteur de l’Artisanat.\n‘’Dans beaucoup d’entreprises, une simple amélioration du niveau d’équipement aurait un impact positif sur l’accroissement de la productivité, l’amélioration de la qualité du produit fini, mais aussi permettrait d’accroître les possibilités commerciales et donc d’accès à la commande publique’’, a estimé le coordonnateur du Projet mobilier national.\nIbrahima Tall s’est engagé à appliquer la vision du chef de l’Etat, Bassirou Diomaye Faye. Il a rappelé que celle-ci ‘’consiste à systématiser la valorisation des acquis de l’expérience (VAE) pour exploiter de façon optimale le capital humain dont dispose l’artisanat et favoriser l’implantation de centres d’artisans locaux (regroupés en sociétés, GIE ou en coopératives), en rapport avec les chambres des métiers d’artisans’’.\n‘’La vision du président est d’intégrer dans les procédures de la commande publique, l’obligation de faire appel à l’artisanat 100% +Made in Sénégal+, afin d’augmenter la part de marché des artisans dans la commande publique et de leur permettre de se formaliser’’, a-t-il expliqué.\nLe coordonnateur du Projet mobilier national a promis d’accorder ‘’une importance sans demi-mesure’’ au renforcement de capacités en faveur des acteurs des 120 corps de métiers de l’artisanat par un système de formation, de perfectionnement soutenu et d’apprentissage pour leur permettre d’être plus compétitifs.\nM. Tall a salué l’action de son prédécesseur, Saloum Ndiaye qui, selon lui, a ‘’posé les bases d’un rayonnement du mobilier national, à travers une stratégie éclairée et un cadre juridique et institutionnel ayant abouti à l’adoption du décret n°2023-1021 du 10 mai 2023 portant création et fixant les règles d’organisation et de fonctionnement du Projet mobilier national’’.\nCette disposition, a-t-il souligné, offre ainsi un élan pour une bonne exécution des missions du projet. Il promet de consolider et capitaliser les acquis ‘’pour toujours plus de résultats’’.\nEconomiste statisticien de formation, Ibrahima Tall a travaillé à l’Agence nationale de la statistique et de la démographie (ANSD). Il y a occupé les postes de chef du bureau des statistiques d’entreprises et chef du service régional de la statistique de Ziguinchor. Il a par la suite pris la direction du service régional de la statistique de Sédhiou.\nSG/ASG/ASB",
    date: "2024-10-27",
  },
  {
    id: "FID63S",
    slug: "50eme-fidak-2024",
    image: "/images/50eme-fidak-2024.webp",
    title:
      "Le PMN à la 50ème FIDAK : Une vitrine du savoir-faire local et de l'entrepreneuriat national",
    description:
      "La 50ème édition de la Foire Internationale de Dakar (FIDAK) a été l’occasion pour le (PMN), sous la direction de son coordonnateur Ibrahima Talla, de mettre en lumière le savoir-faire local. Le stand mis en place par le PMN a offert une vitrine dynamique, mettant en valeur les produits et services locaux tout en reflétant l'engagement indéfectible du coordonnateur à accompagner les acteurs nationaux pour leur permettre d'accéder efficacement à la commande publique.\n Cette initiative s'inscrit dans une démarche de valorisation des talents locaux, de promotion de l'entrepreneuriat et de renforcement de l'économie nationale. À travers cette plateforme, le PMN a illustré sa mission de soutenir les entreprises locales, notamment en les formant aux mécanismes de passation de marchés publics et en les outillant pour répondre aux exigences de compétitivité et de qualité.\n La participation à cet événement phare a permis de sensibiliser davantage de partenaires et de renforcer le rôle du PMN comme catalyseur pour le développement économique inclusif.",
    date: "2024-11-11",
  },
  {
    id: "JRN63S",
    slug: "journee-de-la-commande-publique",
    image: "/images/journee-de-la-commande-publique.webp",
    title:
      "Journée de la Commande Publique : Le PMN au cœur de la territorialisation à la 32ᵉ FIDAK",
    description:
      "Journée de la Commande Publique \n Le Projet Mobilier National a l'immense plaisir d'annoncer un événement d'envergure à l'occasion de la 32ᵉ édition de la Foire Internationale de Dakar (FIDAK). \n Le Mercredi 11 décembre 2024 À partir de 10h à la Salle 04 Avril, CICES \n Thème : La territorialisation de la commande publique\nCette journée exceptionnelle sera l'occasion de débattre, d'échanger et de proposer des solutions pour une meilleure appropriation de la commande publique au service du développement des territoires.\nLe coordonnateur Ibrahima Talla et toute son équipe, dynamique et engagée, vous invitent à participer à cet événement unique qui réunira des acteurs majeurs du secteur public et privé.\n Soyez nombreux au rendez-vous pour contribuer à façonner l'avenir de la commande publique !",
    date: "2024-12-17",
  },
];

export const partners = [
  "/images/logo-sn-hlm.png",
  "/images/logo-dmta.png",
  "/images/logo-armp.png",
  "/images/logo-uncm.png",
  "/images/logo-la-kora.png",
  "/images/logo-der-fj.png",
  "/images/logo-ADEPME.png",
];

export const achievements = [
  
    {
    src: "/images/appli.png",
    thumbnail: "/images/appli-256.png",
  },
  {
    src: "/images/arcop-40_artisan.jpg",
    thumbnail: "/images/arcop-40_artisan.jpg",
  },
  {
    src: "/images/realisa1.webp",
    thumbnail: "/images/realisa1-256.webp",
  },
  {
    src: "/images/masque.webp",
    thumbnail: "/images/masque-256.webp",
  },
  {
    src: "/images/zampa.webp",
    thumbnail: "/images/zampa-256.webp",
  },
  {
    src: "/images/tenues-scolaires.webp",
    thumbnail: "/images/tenues-scolaires-256.webp",
  },
  {
    src: "/images/table-banc.webp",
    thumbnail: "/images/table-banc-256.webp",
  },
  {
    src: "/images/kaolack-1200.webp",
    thumbnail: "/images/kaolack-256.webp",
  },
  {
    src: "/images/kedougou.webp",
    thumbnail: "/images/kedougou-256.webp",
  },
  {
    src: "/images/visit.webp",
    thumbnail: "/images/visit-256.webp",
  },
  {
    src: "/images/seca.webp",
    thumbnail: "/images/seca-256.webp",
  },
  {
    src: "/images/zodar.webp",
    thumbnail: "/images/zodar-256.webp",
  },
  
];

export const regulationsFiles = [
  {
    id: "decret-pmn",
    title:
      "Décret n° 2023-1021 portant création et fixant les règles d'organisation et de fonctionnement du Projet Mobilier National",
    details: "1 fichier·s",
    size: 0.86,
    url: "Scan-decret-pmn.pdf",
  },
  {
    id: "arco-version-2025",
    title:
      "ARCOP-VERSION-2025 :la commande publique entre régularité et performance",
    details: "1 fichier·s",
    size: 0.1,
    url: "Communication-ARCOP-CAMP-derniere-version-2025.pdf",
  },
  {
    id: "pmn-manuel-de-procedures",
    title:
      "PMN : manuel de procédures admin, finan et comptables, chap 2 Organisation et fonctionnement, version finale – Mars 2024",
    details: "1 fichier·s",
    size: 0.7,
    url: "MPAFC_PMN_CHAPITRE.pdf",
  },
  {
    id: "aao-pmn-217",
    title:
      "Avis d'Appel d'Offres Ouvert National : Projet Mobilier National du Ministère du Tourisme et de l'Artisanat (MTA) AOO No F-PMN-217",
    details: "1 fichier·s",
    size: 0.72,
    url: "AAO-F-PMN-217-QUOTIDIEN.pdf",
  },

  {
    id: "arcop-newsletter",
    title:
      "Cette newsletter donne un aperçu sur les activités de l’ARCOP, del’actualité de la Commande publique...",
    details: "1 fichier·s",
    size: 0.58,
    url: "arcop.pdf",
  },
  {
    id: "arrete-12061",
    title: "Arrêté interministériel n°12061 du 14 Juillet 2017 fixant...",
    details: "1 fichier·s",
    size: 0.75,
    url: "arrete-12061-guide_2.pdf",
  },
  {
    id: "decret-aspt",
    title: "Décret portant création de l’Agence Sénégalaise de Promotion...",
    details: "1 fichier·s",
    size: 0.59,
    url: "DECRET-CREANT-ASPT.pdf",
  },
  {
    id: "decret-organisation-mtl",
    title:
      "Décret n°2023-1711 portant organisation du Ministère du Tourisme...",
    details: "1 fichier·s",
    size: 0.22,
    url: "decret-organisation-mtl.pdf",
  },
  {
    id: "decret-reglementation-av",
    title: "Décret n°2005-144 du 02 Mars 2005 portant Règlementation...",
    details: "1 fichier·s",
    size: 0.59,
    url: "decret-portant-reglementation-des-av.pdf",
  },
  {
    id: "reglement-uemoa",
    title: "Règlement n° 01/2014/CM/UEMOA établissant le code de...",
    details: "1 fichier·s",
    size: 0.12,
    url: "UEMOA.pdf",
  },
  {
    id: "arrete-05550",
    title: "Arrêté modifiant l'Arrêté 05550 du 10 Mai 1988 fixant...",
    details: "1 fichier·s",
    size: 0.26,
    url: "Arrete-05550-du-10-Mai-1988.pdf",
  },
  {
    id: "vision-2050",
    title:
      "VISION SÉNÉGAL 2050 Stratégie nationale de Développement 2025 2029...",
    details: "1 fichier·s",
    size: 1.02,
    url: "Communication-Vision-20250-DGPPE-CAMP-2025.pdf",
  },
  {
    id: "transformation-digitale-administration",
    title: "Transformation Digitale de l’administration...",
    details: "1 fichier·s",
    size: 0.19,
    url: "Communication-SENUM-CAMP-2025.pdf",
  },
  {
    id: "communication-pole-comm-pr",
    title:
      "Communication des administrations publiques à l’ère des réseaux socionumériques...",
    details: "1 fichier·s",
    size: 0.74,
    url: "Communication-Pole-Comm-Pr-CAMP-2025.pdf",
  },
  {
    id: "budget-2025",
    title:
      "LE BUDGET 2025 : un tournant decisif dans la gestion des politiques publiques au senegal...",
    details: "1 fichier·s",
    size: 0.95,
    url: "Communication-LFI-2025-MFB-DGB-CAMP-2025.pdf",
  },
  {
    id: "communication-ige",
    title: "Bonne gouvernance et contrôle de l’action publique...",
    details: "1 fichier·s",
    size: 0.91,
    url: "Communication-IGE-CAMP-2025.pdf",
  },
  {
    id: "communication-cour-des-comptes",
    title:
      "Conférence des administrateurs et managers publics cicad, le 20 janvier 2025...",
    details: "1 fichier·s",
    size: 1.28,
    url: "Communication-Cour-des-Comptes-CAMP-2025.pdf",
  },
  {
    id: "communication-controle-financier",
    title: "Communication contrôle financier...",
    details: "1 fichier·s",
    size: 0.8,
    url: "Communication-Controle-Financier-CAMP-2025.pdf",
  },
  {
    id: "communication-bom",
    title: "Organisation et fonctionnement des administrations de l’etat...",
    details: "1 fichier·s",
    size: 0.7,
    url: "Communication-BOM-CAMP-2025.pdf",
  },
];

export const galleryItems = [
  {
    src: "/images/arcop.jpg",
    thumbnail: "/images/arcop-256.jpg",
  },
  {
    src: "/images/arcop3.jpg",
    thumbnail: "/images/arcop3-256.jpg",
  },
  {
    src: "/images/arcop2.jpg",
    thumbnail: "/images/arcop2-256.jpg",
  },
  {
    src: "/images/arcop4.jpg",
    thumbnail: "/images/arcop4-256.jpg",
  },
  {
    src: "/images/atelier1.jpg",
    thumbnail: "/images/atelier1-256.jpg",
  },
  {
    src: "/images/atelier2.jpg",
    thumbnail: "/images/atelier2-256.jpg",
  },
  {
    src: "/images/atelier5.jpg",
    thumbnail: "/images/atelier5-256.jpg",
  },
  {
    src: "/images/ct.jpg",
    thumbnail: "/images/ct-256.jpg",
  },
  {
    src: "/images/president.jpg",
    thumbnail: "/images/president-256.jpg",
  },
  {
    src: "/images/atelier6.jpg",
    thumbnail: "/images/atelier6-256.jpg",
  },
  {
    src: "/images/atelier8.jpg",
    thumbnail: "/images/atelier8-256.jpg",
  },
  {
    src: "/images/atelier7.jpg",
    thumbnail: "/images/atelier7-256.jpg",
  },
  
  {
    src: "/images/copil025.webp",
    thumbnail: "/images/copil025-256.webp",
  },
  {
    src: "/images/copil028.webp",
    thumbnail: "/images/copil028-256.webp",
  },
  {
    src: "/images/copil026.webp",
    thumbnail: "/images/copil026-256.webp",
  },
  {
    src: "/images/copil027.webp",
    thumbnail: "/images/copil027-256.webp",
  },
  {
    src: "/images/copil030.webp",
    thumbnail: "/images/copil030-256.webp",
  },
  {
    src: "/images/copil029.webp",
    thumbnail: "/images/copil029-256.webp",
  },
  {
    src: "/images/photo-v10.jpg",
    thumbnail: "/images/photo-vv10.jpg",
  },
  {
    src: "/images/photo-v3.jpg",
    thumbnail: "/images/photo-vv3.jpg",
  },
  {
    src: "/images/photo-v1.jpg",
    thumbnail: "/images/photo-vv1.jpg",
  },
  {
    src: "/images/photo-v2.jpg",
    thumbnail: "/images/photo-vv2.jpg",
  },

  {
    src: "/images/photo-v9.jpg",
    thumbnail: "/images/photo-vv9.jpg",
  },
  {
    src: "/images/photo-v4.jpg",
    thumbnail: "/images/photo-vv4.jpg",
  },
  
  {
    src: "/images/photo-v6.jpg",
    thumbnail: "/images/photo-vv6.jpg",
  },
  {
    src: "/images/photo-v7.jpg",
    thumbnail: "/images/photo-vv7.jpg",
  },
  {
    src: "/images/photo-v8.jpg",
    thumbnail: "/images/photo-vv8.jpg",
  },

  {
    src: "/images/signature-1.webp",
    thumbnail: "/images/signature.webp",
  },
  {
    src: "/images/sign2.webp",
    thumbnail: "/images/sign2-256.webp",
  },
  {
    src: "/images/sign3.webp",
    thumbnail: "/images/sign3-256.webp",
  },
  {
    src: "/images/sign5.webp",
    thumbnail: "/images/sign5-256.webp",
  },
  {
    src: "/images/sign6.webp",
    thumbnail: "/images/sign6-256.webp",
  },
  {
    src: "/images/sign7.webp",
    thumbnail: "/images/sign7-256.webp",
  },
  {
    src: "/images/sign8.webp",
    thumbnail: "/images/sign8-256.webp",
  },
  {
    src: "/images/sign9.webp",
    thumbnail: "/images/sign9-256.webp",
  },
  {
    src: "/images/sign10.webp",
    thumbnail: "/images/sign10-256.webp",
  },
  {
    src: "/images/sign11.webp",
    thumbnail: "/images/sign11-256.webp",
  },
  {
    src: "/images/sign12.webp",
    thumbnail: "/images/sign12-256.webp",
  },
  {
    src: "/images/aspit3.webp",
    thumbnail: "/images/aspit3-256.webp",
  },
  {
    src: "/images/aspit2.webp",
    thumbnail: "/images/aspit2-256.webp",
  },
  {
    src: "/images/aspit1.webp",
    thumbnail: "/images/aspit1-256.webp",
  },
  {
    src: "/images/anpej1.webp",
    thumbnail: "/images/anpej1-256.webp",
  },
  {
    src: "/images/anpej2.webp",
    thumbnail: "/images/anpej2-256.webp",
  },
  {
    src: "/images/demo1.webp",
    thumbnail: "/images/demo1-256.webp",
  },
  {
    src: "/images/visite-1.webp",
    thumbnail: "/images/visite-1-256.webp",
  },
  {
    src: "/images/r1.webp",
    thumbnail: "/images/r1-256.webp",
  },
  {
    src: "/images/cop1.webp",
    thumbnail: "/images/cop1-256.webp",
  },
  {
    src: "/images/cop2.webp",
    thumbnail: "/images/cop2-256.webp",
  },
  
  {
    src: "/images/fida1.webp",
    thumbnail: "/images/fida1-256.webp",
  },
  {
    src: "/images/cop4.webp",
    thumbnail: "/images/cop4-256.webp",
  },
  {
    src: "/images/fida2.webp",
    thumbnail: "/images/fida2-256.webp",
  },
  {
    src: "/images/press1.webp",
    thumbnail: "/images/press1-256.webp",
  },
  {
    src: "/images/passation.webp",
    thumbnail: "/images/passation-256.webp",
  },
  {
    src: "/images/equipe.webp",
    thumbnail: "/images/equipe-256.webp",
  },
  {
    src: "/images/couture-kaolack.webp",
    thumbnail: "/images/couture-kaolack-256.webp",
  },
  {
    src: "/images/kedougou-bois.webp",
    thumbnail: "/images/kedougou-bois-256.webp",
  },
  {
    src: "/images/cfa.webp",
    thumbnail: "/images/cfa-256.webp",
  },
  {
    src: "/images/cfa2.webp",
    thumbnail: "/images/cfa2-256.webp",
  },
  {
    src: "/images/lancement-tenu.webp",
    thumbnail: "/images/lancement-tenu-256.webp",
  },
  {
    src: "/images/visite1.webp",
    thumbnail: "/images/visite1-256.webp",
  },
  {
    src: "/images/visite2.webp",
    thumbnail: "/images/visite2-256.webp",
  },
  {
    src: "/images/visite3.webp",
    thumbnail: "/images/visite3-256.webp",
  },
  {
    src: "/images/visite4.webp",
    thumbnail: "/images/visite4-256.webp",
  },
  {
    src: "/images/visite5.webp",
    thumbnail: "/images/visite5-256.webp",
  },
  {
    src: "/images/coordo-adjoint.webp",
    thumbnail: "/images/coordo-adjoint-256.webp",
  },
  {
    src: "/images/ministre-coordo.webp",
    thumbnail: "/images/ministre-coordo-256.webp",
  },
  {
    src: "/images/reunion.webp",
    thumbnail: "/images/reunion-256.webp",
  },
  {
    src: "/images/visite8.webp",
    thumbnail: "/images/visite8-256.webp",
  },
  {
    src: "/images/visite9.webp",
    thumbnail: "/images/visite9-256.webp",
  },
  {
    src: "/images/visite6.webp",
    thumbnail: "/images/visite6-256.webp",
  },
  {
    src: "/images/visite7.webp",
    thumbnail: "/images/visite7-256.webp",
  },
  {
    src: "/images/visite9.webp",
    thumbnail: "/images/visite9-256.webp",
  },
  {
    src: "/images/f1.webp",
    thumbnail: "/images/f1-256.webp",
  },
  {
    src: "/images/f2.webp",
    thumbnail: "/images/f2-256.webp",
  },
  {
    src: "/images/f3.webp",
    thumbnail: "/images/f3-256.webp",
  },
  {
    src: "/images/f4.webp",
    thumbnail: "/images/f4-256.webp",
  },
  {
    src: "/images/f5.webp",
    thumbnail: "/images/f5-256.webp",
  },
  {
    src: "/images/f6.webp",
    thumbnail: "/images/f6-256.webp",
  },
  {
    src: "/images/f7.webp",
    thumbnail: "/images/f7-256.webp",
  },
  {
    src: "/images/f8.webp",
    thumbnail: "/images/f8-256.webp",
  },
];

export interface RegulationTypes {
  id: string;
  title: string;
  details: string;
  size: number;
  url: string;
}

export interface Article {
  id: string;
  slug: string;
  image: string;
  title: string;
  description: string;
  date: string;
}

export const parsedDate = (date: string) => {
  const convertedDate = new Date(date).toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return convertedDate;
};
